import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { AngularFireAuth } from 'angularfire2/auth';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-bid',
  templateUrl: './bid.component.html',
  styleUrls: ['./bid.component.css']
})
export class BidComponent implements OnInit {
  customBidAmount: number;
  constructor(public sharedService: SharedService, public afAuth: AngularFireAuth, public dialog: MatDialog) { }

  ngOnInit() {
  }

  bid() {
    const player = this.sharedService.getCurrentPlayer();
    player.bids.push(
      { amount: this.customBidAmount,
        bidder: this.afAuth.auth.currentUser.displayName
      });
    player.times.push({
      time: new Date().getTime(),
      type: 'bid'
    });
    this.sharedService.playersCol.doc(player.id).update(player);
  }

  upBidMinimum() {
    this.sharedService.getCurrentPlayer().bids.push(
      { amount: this.sharedService.getMinimumNextBid(),
        bidder: this.afAuth.auth.currentUser.displayName
      });
      this.sharedService.getCurrentPlayer().times.push({
        time: new Date().getTime(),
        type: 'bid'
      });
    this.sharedService.playersCol.doc(this.sharedService.getCurrentPlayer().id).update(this.sharedService.getCurrentPlayer());
  }

  canCustomBid(clock) {
    if (this.sharedService.getMinimumNextBid()
        && this.customBidAmount >= this.sharedService.getMinimumNextBid()
        && this.sharedService.getCurrentPlayerTimeLeft(clock) > 0
        && !this.sharedService.isPaused()) {
      return false;
    } else {
      return true;
    }
  }

  canBid(clock) {
    if (this.sharedService.getCurrentPlayerTimeLeft(clock) > 0
        && !this.sharedService.isPaused()) {
      return false;
    } else {
      return true;
    }
  }

  overrideBid() {
    const dialogRef = this.dialog.open(OverrideBidComponent, {
      height: '200px',
      width: '400px'
    });
  }

}

@Component({
  selector: 'app-override-bid-dialog',
  templateUrl: 'bid-override.html'
})
export class OverrideBidComponent {
  amount: number;
  constructor(
    public dialogRef: MatDialogRef<OverrideBidComponent>,
    public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  overrideBid(): void {
    if (this.amount) {
      this.sharedService.overrideBid(this.amount);
      this.dialogRef.close();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/bid/bid.component.ts